/* Herram · Vistos recientemente (21-oct-2026, idea de Jorge al ver Sodimac).
   En la ficha guarda el producto en este navegador (últimos 8, sin cuentas ni cookies de terceros).
   En búsqueda y categorías muestra una fila bajo el listado, solo si la persona ya vio productos.
   Las tarjetas se piden recién al bajar hasta esa zona (sección herram-vistos-card), con precio y stock al día. */
(function () {
  var KEY = 'herram_vistos', MAX = 8;
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (m) {
    var h = decodeURIComponent(m[1]), l = read().filter(function (x) { return x !== h; });
    l.unshift(h);
    try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, MAX))); } catch (e) {}
    return;
  }
  var grid = document.getElementById('ProductGridContainer');
  var list = read();
  if (!grid || !list.length) return;
  /* Va dentro de la columna de productos (bajo la paginación), alineada con la grilla; al filtrar, Dawn reemplaza
     el contenido de #ProductGridContainer, así que se vuelve a poner al final */
  var box = document.createElement('section');
  box.className = 'hrv';
  box.setAttribute('aria-labelledby', 'hrv-h');
  grid.appendChild(box);
  new MutationObserver(function () { if (!grid.contains(box)) grid.appendChild(box); }).observe(grid, { childList: true });
  var chev = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var build = function (cards) {
    if (!cards.length) { box.remove(); return; }
    box.innerHTML =
      '<div class="hrv__top"><h2 class="hrv__h" id="hrv-h">Vistos recientemente</h2>' +
      '<div class="hrv__nav"><button type="button" class="hrv__b" data-dir="-1" aria-label="Productos anteriores">' + chev('M15 18l-6-6 6-6') + '</button>' +
      '<button type="button" class="hrv__b" data-dir="1" aria-label="Más productos">' + chev('M9 6l6 6-6 6') + '</button></div></div>' +
      '<ul class="hrv__track" role="list"></ul>' +
      '<div class="hrv-mnav"><button type="button" class="hrv__b" data-dir="-1" aria-label="Productos anteriores">' + chev('M15 18l-6-6 6-6') + '</button>' +
      '<span aria-live="polite"></span><button type="button" class="hrv__b" data-dir="1" aria-label="Más productos">' + chev('M9 6l6 6-6 6') + '</button></div>';
    var tr = box.querySelector('.hrv__track');
    cards.forEach(function (c) { var li = document.createElement('li'); li.className = 'hrv__slide'; li.appendChild(c); tr.appendChild(li); });
    var bs = box.querySelectorAll('.hrv__b'), cnt = box.querySelector('.hrv-mnav span');
    var upd = function () {
      var a = tr.scrollLeft < 8, z = tr.scrollLeft + tr.clientWidth > tr.scrollWidth - 8;
      bs.forEach(function (b) { b.disabled = b.dataset.dir === '-1' ? a : z; });
      box.classList.toggle('hrv--fits', tr.scrollWidth <= tr.clientWidth + 8);
      var it = tr.children, st = it.length > 1 ? it[1].offsetLeft - it[0].offsetLeft : 1;
      var i = Math.min(it.length, Math.round(tr.scrollLeft / (st || 1)) + 1);
      if (z) i = Math.max(1, it.length - Math.round(tr.clientWidth / (st || 1)) + 1);
      cnt.textContent = i + '/' + it.length;
    };
    bs.forEach(function (b) { b.addEventListener('click', function () { tr.scrollBy({ left: Number(b.dataset.dir) * (tr.clientWidth + 16), behavior: 'smooth' }); }); });
    tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  };
  var load = function () {
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=herram-vistos-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { var d = t && new DOMParser().parseFromString(t, 'text/html').querySelector('.hrv__card'); return d && d.firstElementChild ? d : null; })
        .catch(function () { return null; });
    })).then(function (r) { build(r.filter(Boolean)); });
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
    io.observe(box);
  } else load();
})();
